import { ManufacturerRepository } from '../data/manufacturer-repository';
import { ManufacturerItem, CreateManufacturerRequest } from '../types/manufacturer-types';

export class CreateManufacturerUseCase {
  constructor(private readonly repository: ManufacturerRepository) {}

  async execute(data: CreateManufacturerRequest): Promise<ManufacturerItem> {
    return this.repository.create(data);
  }
}
